import React, { useEffect } from 'react';
import { Typography } from '@vtblife/uikit';
import Icon from '@vtblife/uikit-icons';

import {
    sendAnalyticsEvent,
    SMART_APP_BANNER_CLICK,
    SMART_APP_BANNER_CLOSE,
    SMART_APP_BANNER_SHOW,
} from '../../analytics';

import './smart-app-banner.module.css';

// css-loader doesn't export global, we use globals for critical extraction
const styles = {
    banner: 'smartAppBanner',
    closeButton: 'smartAppBannerClose',
    title: 'smartAppBannerTitle',
    cta: 'smartAppBannerCta',
};

export const SMART_APP_BANNER_HREF = '/mobile-app/';

export interface SmartAppBannerProps {
    onClose: () => void;
    href?: string;
}

export const SmartAppBanner: React.FC<SmartAppBannerProps> = ({ onClose, href = SMART_APP_BANNER_HREF }) => {
    useEffect(() => {
        sendAnalyticsEvent(SMART_APP_BANNER_SHOW);
    }, []);

    const handleClose = () => {
        sendAnalyticsEvent(SMART_APP_BANNER_CLOSE);
        onClose();
    };

    return (
        <div className={styles.banner} data-test="smart-app-banner">
            <button
                type="button"
                className={styles.closeButton}
                onClick={handleClose}
                aria-label="Закрыть"
                data-test="smart-app-banner-close"
            >
                <Icon name="times" size="s" color="white" />
            </button>
            <Typography color="white-500" variant="secondary" className={styles.title}>
                В приложении удобнее
            </Typography>
            <a
                className={styles.cta}
                href={href}
                onClick={() => sendAnalyticsEvent(SMART_APP_BANNER_CLICK)}
                data-test="smart-app-banner-cta"
            >
                Скачать
            </a>
        </div>
    );
};
